<template>
  <div>
    <b-row class="mb-1">
      <b-col class="col-6">
        <span class="d-flex">
          <label for="" class="mr-1">Edad:</label>
          <p >{{ stEdad }}</p>
          <span class="score mx-1">{{ printScore(score.edad) }} </span>
        </span>
      </b-col>

      <b-col class="col-6">
        <span class="d-flex">
          <label for="" class="mr-1">Sexo:</label>
          <p>{{ values.sexo === 1 ? 'Mujer' : 'Hombre'  }}</p>
        </span>
      </b-col>
    </b-row>


    <b-row class="my-1">
      <b-col>
        <b-form-checkbox switch v-model="values.fuma">
          Fuma
          <span class="score mx-1">
            {{ printScore(score.fuma) }} 
          </span>
        </b-form-checkbox>
      </b-col>

      <b-col>
        <b-form-checkbox switch v-model="values.diabetes">
          Diabetes
          <span class="score mx-1">
            {{ printScore(score.diabetes) }}
          </span>
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="my-1 align-items-center">
      <b-col class="col-3">
        <label for="" class="mr-1">Colesterol Total:</label>
      </b-col>

      <b-col class="col-7">
        <b-input-group :append="values.colesterolTotal">
          <b-form-input
            type="range"
            min="0"
            max="300"
            v-model="values.colesterolTotal"
          />
        </b-input-group>
        
      </b-col>
      
      <span class="score">{{ printScore(score.colesterolTotal) }}</span>
    </b-row>
    
    <b-row class="my-1 align-items-center">
      <b-col class="col-3">
        <label for="" class="mr-1">Colesterol HDL:</label>
      </b-col>

      <b-col class="col-7">
        <b-input-group :append="values.colesterolHDL">
          <b-form-input
            type="range"
            min="0"
            max="100"
            v-model="values.colesterolHDL"
          />
        </b-input-group>
      </b-col>
      <span class="score">{{ printScore(score.colesterolHDL) }}</span>

    </b-row>

    <b-row class="my-1 align-items-center">
      <b-col class="col-3">
        <label for="" class="mr-1">Presion Arterial Sistolica:</label>
      </b-col>

      <b-col class="col-7">
        <b-input-group :append="values.presionArterialSistolica">
          <b-form-input
            type="range"
            min="0"
            max="200"
            v-model="values.presionArterialSistolica"
          />
        </b-input-group>
        
      </b-col>
      <span class="score">{{ printScore(score.presionArterialSistolica) }}</span>
    </b-row>

    <b-row class="my-1 align-items-center">
      <b-col class="col-2">
        <span>Riesgo:</span>
      </b-col>
      <b-col class="col-7">
        <b-progress 
          :value="score.total"
          :max="20" 
          :variant="colorBarTotal"
          striped
          show-value
        />

      </b-col>

      <b-col>
        <span class="score">TOTAL: {{score.total}} pts</span>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "EscalaFramingham",

  data(){
    return {
      
      values:{
        edad: this.stEdad,
        sexo: 2, // mujer1, hombre2
        fuma:false,
        diabetes:false,
        colesterolTotal:'0',
        colesterolHDL:'0',
        presionArterialSistolica:'0',
      },

      colorBarTotal: 'success',
      
      score:{
        total:0,
        edad:0,
        fuma:0,
        diabetes:0,
        colesterolTotal:0,
        colesterolHDL:0,
        presionArterialSistolica:0,
      },

      ageRanges: [
        { min: 20, max: 34, points: -9 },
        { min: 35, max: 39, points: -4 },
        { min: 40, max: 44, points: 0 },
        { min: 45, max: 49, points: 3 },
        { min: 50, max: 54, points: 6 },
        { min: 55, max: 59, points: 8 },
        { min: 60, max: 64, points: 10 },
        { min: 65, max: 69, points: 12 },
        { min: 70, max: 74, points: 14 },
        { min: 75, max: 79, points: 16 },
      ]
    }
  },

  methods: {
    calculateScore(){
      this.calculatePointsByEdad();
      this.calculatePointsByFumar();
      this.calculatePointsByDiabetes();
      this.calculatePointsByColesterolTotal();
      this.calculatePointsByColesterolHDL();
      this.calculatePointsByPresionArterial();
      this.calculateScoreTotal();
    },

    calculatePointsByEdad(){
      const ageRange = this.ageRanges.find(range => this.stEdad >= range.min && this.stEdad <= range.max);
      this.score.edad = ageRange ? ageRange.points : 0;
    },

    calculatePointsByFumar(){
      this.score.fuma = this.values.fuma 
        ? this.values.sexo === 1 ? 2 : 4
        : 0
    },

    calculatePointsByDiabetes(){
      this.score.diabetes = this.values.diabetes ? 3 : 0
    },

    calculatePointsByColesterolTotal(){
      const { colesterol, sexo } = this.values;

      const points = colesterol < 160
        ? 0
        : colesterol < 200
          ? sexo === 1 ? 1 : 2
          : colesterol < 240 
            ? sexo === 1 ? 3 : 4
            : colesterol < 280
              ? sexo === 1 ? 4 : 5
              : sexo === 1 ? 5 : 7;

      this.score.colesterolTotal = points;
    },

    calculatePointsByColesterolHDL(){
      const colesterol = this.values.colesterolHDL;
      
      const points = colesterol < 40
        ? 2
        : colesterol < 50
          ? 1
          : colesterol < 60
            ? 0
            : -1;

      this.score.colesterolHDL = points;
    },

    calculatePointsByPresionArterial(){
      const presion = this.values.presionArterialSistolica;
      const tratamiento = true;

      this.score.presionArterialSistolica = 
        presion < 120 
          ? 0 
          : presion < 130 
            ? tratamiento ? 3 : 1 
            : presion < 140 
              ? tratamiento ? 4 : 2 
              : presion < 160 
                ? tratamiento ? 5 : 3
                : tratamiento ? 6 : 4;
    },

    calculateScoreTotal(){
      this.score.total = 
        this.score.edad
        + this.score.fuma
        + this.score.diabetes
        + this.score.colesterolTotal
        + this.score.colesterolHDL
        + this.score.presionArterialSistolica;

      this.colorBarTotal = 
        this.score.total < 10
          ? 'success' 
          : this.score.total < 16
            ? 'info'
            : 'danger';
    },

    printScore(score){
      return score > 0
        ? `+ ${score} pts`
        : `${score} pts`
    }
  },

  computed: {
    ...mapState({
      stEdad: state => state.atencionCita.dataCita?.paciente?.persona.edad,
    }),


    edadPaciente(){
      return this.stEdad
    }
  },

  watch: {
    values: {
      deep: true,
      handler(newValue){
        this.calculateScore();
        this.$store.commit('setFramingham', newValue)
      },
    },

    edadPaciente: {
      deep: true,
      handler(newValue){
        this.values.edad = newValue;
      },
    },
  },
  
}
</script>

<style>
  .score {
    color: rgb(54, 91, 214);
  }
</style>